import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PerformanceGraphComponent } from './performance-graph.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { ChartModule } from 'angular-highcharts';
import { CustomDatePickerModule } from 'src/app/shared/components/custom-date-picker/custom-date-picker.module';
import { CustomDropdownModule } from 'src/app/shared/components/custom-dropdown/custom-dropdown.module';
import { CustomInputModule } from 'src/app/shared/components/custom-input/custom-input.module';
import { ExpansionPanelModule } from 'src/app/shared/components/expansion-panel/expansion-panel.module';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { PerformanceGraphRoutingModule } from './performance-graph-routing.module';



@NgModule({
  declarations: [
    PerformanceGraphComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
        MaterialModule,
        MatPaginatorModule,
        MatSortModule,
        FormsModule,
        CustomDatePickerModule,
        CustomInputModule,
        CustomDropdownModule,
        ExpansionPanelModule,
        ChartModule,
        PerformanceGraphRoutingModule
  ],
  exports:[
    PerformanceGraphComponent
  ]
})
export class PerformanceGraphModule { }
